import { TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'

type Props = {
  initTime: string
  type: string
  label: string
  size?: 'small' | 'medium' | undefined
  placeholder: string
  onFocusHandler?: ((e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => void) | undefined
  onBlurHandler?: ((e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => void) | undefined
  onTimeChange?: (val: string) => void
}

export const isValid = (val: string): boolean => {
  const regexp = /^\d{0,2}?:?\d{0,2}$/

  const [hoursStr, minutesStr] = val.split(':')

  if (!regexp.test(val)) {
    return false
  }

  const hours = Number(hoursStr)
  const minutes = Number(minutesStr)

  const isValidHour = (hour: number) => Number.isInteger(hour) && hour >= 0 && hour < 24
  const isValidMinutes = (minutes: number) => (Number.isInteger(minutes) && hours >= 0 && hours < 24) || Number.isNaN(minutes)

  if (!isValidHour(hours) || !isValidMinutes(minutes)) {
    return false
  }

  if (minutes < 10 && Number(minutesStr[0]) > 5) {
    return false
  }

  const valArr = val.indexOf(':') !== -1
    ? val.split(':')
    : [val]

  // check mm and HH
  if (valArr[0] && valArr[0].length && (parseInt(valArr[0], 10) < 0 || parseInt(valArr[0], 10) > 23)) {
    return false
  }

  return !(valArr[1] && valArr[1].length && (parseInt(valArr[1], 10) < 0 || parseInt(valArr[1], 10) > 59))
}

const TimeInput: React.FC<Props> = ({ initTime, onFocusHandler, onBlurHandler, onTimeChange, type, size, placeholder, label }) => {
  const [time, setTime] = useState(initTime || '')
  const _input = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    setTimeout(() => {
      _input && _input.current && _input.current.focus()
    }, 0)
  })

  let lastVal = ''

  const onChangeHandler = (val: string) => {
    if (val === time) {
      return
    }
    if (isValid(val) || val === '' || val === undefined) {
      if (val === '' || val === undefined) onTimeChange && onTimeChange(val)
      if (val.length === 2 && lastVal.length !== 3 && val.indexOf(':') === -1) {
        val = val + ':'
      }

      if (val.length === 2 && lastVal.length === 3) {
        val = val.slice(0, 1)
      }

      if (val.length > 5) {
        return false
      }

      lastVal = val

      setTime(val)
      if (val.length === 5) {
        onTimeChange && onTimeChange(val)
      }
    }
  }

  return (
    <TextField
      type={type || 'tel'}
      placeholder={placeholder}
      value={time}
      label={label}
      size={size}
      onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => onChangeHandler(e.target.value)}
      onFocus={(onFocusHandler) ? (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => onFocusHandler(e) : undefined}
      onBlur={(onBlurHandler) ? (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => onBlurHandler(e) : undefined}
      ref={_input}
      InputLabelProps={{
        shrink: true,
      }}
    />
  )
}

export default TimeInput
